var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.spaceLoading || _vm.postLoading)?_c('Loader'):_vm._e(),(_vm.lastPost)?_c('PostView',{attrs:{"isShareSpace":true,"postID":_vm.lastPost.id}}):(_vm.post_error != null || _vm.error != null)?_c('div',[_c('NotFound')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }